import React from 'react';
import { useEventListContext } from '../context/EventListProvider';
import CheckboxGroup from './CheckboxGroup';
import DateRange from './DateRange';
import FilterButtons from './FilterButtons';

const FacetDialog = () => {
  const { i18n, closeDialog, facets, dialog } = useEventListContext();

  return (
    <dialog ref={dialog}>
      <button
        className="event-list__close-button"
        title={i18n.closeFilter}
        type="button"
        onClick={closeDialog}
      >
        <svg
          width="240"
          height="240"
          className="icon"
          viewBox="0 0 240 240"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="currentColor"
            d="M152.929 72.929 167.07 87.07 134.141 120l32.93 32.929-14.142 14.142-32.93-32.93-32.928 32.93L72.93 152.93l32.929-32.93-32.93-32.928L87.072 72.93 120 105.858z"
          />
        </svg>
      </button>

      <div className="event-list__facets">
        {facets?.map((i) => (
          <React.Fragment key={i.attribute}>
            {i.type === 'checkbox-group' && (
              <CheckboxGroup
                key={i.attribute}
                label={i.label}
                attribute={i.attribute}
                limit={6}
                showMore
              />
            )}

            {i.type === 'date-range' && (
              <DateRange
                key={i.attribute}
                label={i.label}
                attribute={i.attribute}
                labels={i.inputLabels}
              />
            )}
          </React.Fragment>
        ))}
      </div>

      <FilterButtons />
    </dialog>
  );
};

export default FacetDialog;
